import { useQuery } from '@tanstack/react-query';

import type { AgentApiCandidateMailsShow } from '@/types/serializers';

import { scheduledRefetchInterval } from '../lib/scheduledAt';

export default function useFetchCandidateMail(mailId: number | null) {
  return useQuery<AgentApiCandidateMailsShow>({
    enabled: mailId !== null,
    queryKey: ['candidateMail', mailId],
    queryFn: async () => {
      const response = await fetch(`/agent/api/candidate_mails/${mailId}`);
      if (!response.ok) {
        throw new Error('候補者メールの取得に失敗しました。');
      }
      return response.json();
    },
    refetchInterval: (query) => {
      const status = query.state.data?.status;
      if (status === 'queued' || status === 'processing') return 3000;
      if (status === 'scheduled')
        return scheduledRefetchInterval([query.state.data?.scheduled_at ?? null]);
      return false;
    },
  });
}
